import { ReactComponent as GenerateIcon } from 'assets/icons/design_ai.svg';
import { LoadingButton } from 'modules/common/components/Button/LoadingButton';
import { useTranslation } from 'react-i18next';

interface GenerateButtonProps {
  onClick: () => void;
  label: string;
  isLoading: boolean;
}

export const GenerateButton = ({ onClick, label, isLoading }: GenerateButtonProps) => {
  const { t } = useTranslation('design_generator', { keyPrefix: 'cardGeneration' });

  return (
    <LoadingButton
      onClick={onClick}
      size='sm'
      variant='purple'
      isLoading={isLoading}
      loadingText={t('generatingText')}
      leftIcon={<GenerateIcon />}
    >
      {label}
    </LoadingButton>
  );
};
